import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AuthService, DialogBase, OrderCustomerModel } from 't4core';
import { LocationInfo } from 't4core';



@Component({
  selector: 'addStakeholderDialog',
  templateUrl: './AddStakeholder.html',
  animations: [
    trigger('formState', [
      state('form', style({
        opacity: 1.0,
        display: 'block'
      })),
      state('success', style({
        opacity: 0,
        display: 'none'
      })),
      transition('success => visible', animate('200ms ease-in')),
      transition('visible => success', animate('200ms ease-out'))
    ]),
    trigger('successState', [
      state('success', style({
        opacity: 1.0,
        display: 'block'
      })),
      state('form', style({
        opacity: 0,
        display: 'none'
      })),
      transition('success => form', animate('200ms ease-in')),
      transition('form => success', animate('200ms ease-out'))
    ])
  ]
})
export class AddStakehholderDialog extends DialogBase {
  public isWorking: boolean = false;
  public state = "form";

  private customers: OrderCustomerModel[];
  public filteredLocations: OrderCustomerModel[];

  public selectedLocation: OrderCustomerModel | null;

  public theForm: FormGroup;

  public ignoreCustomerId: number;

  constructor(
    public dialogRef: MatDialogRef<AddStakehholderDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private authService: AuthService,
    private formBuilder: FormBuilder
  ) {
    super("ImpersonationDialog");

    this.theForm = this.formBuilder.group({
      searchText: ['', Validators.required]
    });

    this.ignoreCustomerId = data.customerId;

    this.isWorking = true;

    this.Api.get<OrderCustomerModel[]>("TurboOrder/GetCustomers").then((x) => {
      this.customers = x
        .sort((x, y) => {
          if (x.Name == y.Name) return 0;
          return x.Name < y.Name ? -1 : 1;
        })
        .filter(x => x.Id != this.ignoreCustomerId); 

      this.isWorking = false;
      this.updateFilter();
    });
  }
  public updateFilter() {
    var search = this.theForm.get("searchText")!.value.toLowerCase();
    var found = 0;

    if (search != "") {
      this.filteredLocations = this.customers.slice().filter((x, index) => {
        var ret = (found < 20) && (
          (x.DeliveryAddressCustomerName && x.DeliveryAddressCustomerName.toLowerCase().indexOf(search) >= 0) ||
          (x.XalAccountNo && x.XalAccountNo.toLowerCase().indexOf(search) >= 0)
        );

        if (ret) found++;
        return ret;
      });

      if (this.filteredLocations.length > 0) this.selectedLocation = this.filteredLocations[0];
    } else {
      this.filteredLocations = [];
      this.selectedLocation = null;
    }
  }

  public selectLocation(location: OrderCustomerModel) {
    if (this.isWorking) return;

    this.selectedLocation = location;
  }

  public impersonate() {
    if (!this.selectedLocation) return;

    console.log("Pressed!");
    console.log(this.selectedLocation);

    this.dialogRef.close(this.selectedLocation);


  }
}
